import { User} from '@/shared/models';

export const AuthApi = {
    async login(params) {
        const loginParams ={
            email:params.email,
            password : params.password,
            from :"vuejs"
          //  "remember-me" : true
        }
        const response = await axios.post('/login',new URLSearchParams(loginParams).toString());
        return  response.data;
    },
    async logout() {
        await axios.post('/logout');
    },
};
